import type React from 'react';

import { Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/Modal';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { MediaHitEmbed } from '../../shared/context';

import { MediaHitsModalList } from './components/MediaHitsModalList';
import { useMediaHitsModalList } from './hooks/useMediaHitsModalList';

export const MediaHitsModal: React.FC<MediaHitsModalProps> = ({ isOpen, onClose, onEmbedsLoaded }) => {
	const { translate } = useI18n();
	const {
		data: { embeds, status, hasNextPage, hasLoadedMore },
		actions: { loadMore, removeMedia },
	} = useMediaHitsModalList(isOpen, onEmbedsLoaded);

	return (
		<Modal
			isOpen={isOpen}
			size="small"
			onClose={onClose}
			onOpenChange={(nextOpen) => {
				if (!nextOpen) onClose();
			}}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
		>
			<ModalHeader title={translate('corgi.petition_gamma.media_mentions.header_title')} />
			<ModalBody>
				<MediaHitsModalList
					embeds={embeds}
					status={status}
					hasNextPage={hasNextPage}
					hasLoadedMore={hasLoadedMore}
					onLoadMore={loadMore}
					removeMedia={removeMedia}
				/>
			</ModalBody>
		</Modal>
	);
};

type MediaHitsModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onEmbedsLoaded?: (embeds: readonly MediaHitEmbed[]) => void;
};
